/**
 * SettlementLnj.jsx — LNJ 마케터 전용 정산서
 *
 * 통합 훅(useSettlement) + 공유 뷰(PcView/MobileView) 사용.
 * UI를 수정하면 PINE/DOT 정산서에도 자동으로 반영됩니다.
 *
 * LNJ 특이사항:
 *   - 미연결 결제 패널에 '카드업로드(ext_revenue_card_approvals)' 섹션 표시
 *   - 연결 API는 PINE 공용 라우트(/api/my/revenue/card_upload/...) 사용
 */
import React from 'react';
import { useSettlement } from '../settlement/useSettlement';
import { MobileView } from '../settlementdot/MobileView';

export default function SettlementLnj() {
  const state = useSettlement('LNJ');
  return <MobileView {...state} />;
}
